import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import SeDropdownSearchInput from './SeDropdownSearchInput';

import styles from './SeDropdownContentMobileHeader.scss';

export default class SeDropdownContentMobileHeader extends Component {
    render() {
        const { searchValue, onClose, onSearchChange, searchPlaceholder, searchEnabled } = this.props;
        const headerClass = classNames({
            [styles.header]: true,
            [styles.noSearch]: !searchEnabled,
        });
        return (
            <div className={headerClass}>
                {searchEnabled ? (
                    <SeDropdownSearchInput
                        className={styles.searchInput}
                        value={searchValue}
                        onClose={onClose}
                        onChange={onSearchChange}
                        searchPlaceholder={searchPlaceholder}
                    />
                ) : null}
                <FormattedMessage id="L_CANCEL_ACTION_BUTTON_Text">
                    {txt => (
                        <button onClick={this.props.onClose} className={styles.btnClose}>
                            {txt}
                        </button>
                    )}
                </FormattedMessage>
            </div>
        );
    }
}

SeDropdownContentMobileHeader.propTypes = {
    onSearchChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    searchEnabled: PropTypes.bool.isRequired,
};
